import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { withRouter } from 'react-router-dom';
import { faqList, technicalFaqsList } from './constants';

const Faq = () => {
   useEffect(() => {
      const element = document.getElementById('landingPage')
      element.scrollIntoView({
         block: "start",
         inline: "nearest"
      });
   }, [])

   return (
      <>
         <div id="landingPage" className='faq-header'>
            <Navbar />
         </div >
         <main className='container details-section'>
            <div className='details-wrap'>
               <div className='mb-5'>
                  <h2>
                     FAQs
                  </h2>
                  {
                     faqList.map((faqData) => {
                        return (
                           <div key={faqData.no}>
                              <h6>{faqData.no}). {faqData.question}</h6>
                              <p>{faqData.answer}</p>
                           </div>
                        )
                     })
                  }
               </div>
               <div className='mb-5'>
                  <h2>
                     Technical FAQs
                  </h2>

                  {
                     technicalFaqsList.map((technicalFaq) => {
                        return <div key={technicalFaq.no}>
                           <h6>{technicalFaq.no}). {technicalFaq.question}</h6>
                           <p>{technicalFaq.answer}</p>
                           {
                              technicalFaq.list && technicalFaq.list.length > 0 ? (
                                 <ul>
                                    {technicalFaq.list.map((technicalFaqListItem, technicalFaqListItemIndex) => {
                                       return <li key={technicalFaqListItemIndex}>{technicalFaqListItem}</li>
                                    })}
                                 </ul>
                              ) : ""
                           }
                        </div>
                     })
                  }
               </div>
            </div>
         </main>

         <Footer />
      </>
   )
};

export default withRouter(Faq);
